export default "__VITE_ASSET__yf$TnhUI__"